import React from 'react';
import { IconProps } from '../types';

export const GameDevelopmentIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_9520_40300)">
            <path
                d="M18.5903 23.1489H12.9722"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M8.47758 25.2699L3.28083 28.9832C2.29766 29.7789 0.752685 28.8506 1.03359 27.6571L3.84264 14.6605C4.264 12.6712 6.08989 11.2124 8.33713 11.2124C9.60121 11.2124 10.7248 11.6103 11.5675 12.406L12.9721 13.8648H18.5902L20.1352 12.406C20.9779 11.6103 22.1015 11.2124 23.2251 11.2124C25.3319 11.2124 27.2982 12.6712 27.7196 14.6605L30.5287 27.6571C30.8096 28.8506 29.405 29.6463 28.2814 28.9832L23.0847 25.2699"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M10.1628 25.8011C11.7142 25.8011 12.9719 24.6136 12.9719 23.1487C12.9719 21.6838 11.7142 20.4963 10.1628 20.4963C8.61142 20.4963 7.35376 21.6838 7.35376 23.1487C7.35376 24.6136 8.61142 25.8011 10.1628 25.8011Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M21.3996 25.8011C22.951 25.8011 24.2087 24.6136 24.2087 23.1487C24.2087 21.6838 22.951 20.4963 21.3996 20.4963C19.8482 20.4963 18.5906 21.6838 18.5906 23.1487C18.5906 24.6136 19.8482 25.8011 21.3996 25.8011Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path d="M15.7825 3V8.74875" stroke={color} strokeWidth="2" />
        </g>
        <defs>
            <clipPath id="clip0_9520_40300">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
